const iState ={
  name:'welcome',
}

  const reducer =  (state=iState,action) => {
    const newState={...state};
    if(action.type=='change_menu')
    { newState.name=action.payload;
       console.log("reducer change_menu:"+JSON.stringify(state));
    }

    // if(action.type=='menulist')
    // {
    //   iState.menuList=action.payload;
    //   console.log("reducer menulist is:"+JSON.stringify(iState));
    // return state;
    // }
    return newState;
  }
export default reducer;